import React, { useMemo } from 'react';
import { ActionType, Integration } from '../services/api/types';
import { P2GSidePanel } from '@parcel2go/legacy-my-account-core/dist/sidepanel';
import ActionInstructions from './ActionInstructions';

interface props {
  integrations: Integration[];
  edit: EditAction;
  close: (accountId: string, followUpAction?: ActionType) => void;
}

export interface EditAction {
  id: string;
  action: ActionType;
}

export default function SelectedAccount(props: props) {
  const integration = useMemo(() => {
    if (!props.edit?.id || !props.integrations) {
      return null;
    }
    return props.integrations.find((x) => x.accounts.find((a) => a.id === props.edit.id));
  }, [props.integrations, props.edit]);

  return (
    <P2GSidePanel
      open={!!integration}
      onClose={() => props.close(null, null)}
      anchor="right"
      width={'700px'}
      title={`${props.edit?.action}`}>
      {integration && (
        <ActionInstructions
          configRequired={false}
          action={props.edit?.action}
          integrationSlug={integration?.slug}
          integrationType={integration?.type}
          onComplete={props.close}
          accountId={props.edit?.id}
        />
      )}
    </P2GSidePanel>
  );
}
